import { Children } from "react";
import classNames from "classnames";

import Icon from "../Utils/Icon";
import { hasHtmlContent } from "../Utils/htmlStringUtils";
import ExcerptableContainer from "../Utils/ExcerptableContainer";
import RichText from "../Utils/RichText";

const PageSectionBlockWithTitleAndDescription = props => {
  const { title, description, collapsible, collapsedHeight, children } = props;

  const hasTitle = hasHtmlContent(title);
  const hasDescription = hasHtmlContent(description);
  const hasChildren = children && Children.count(children) > 0;

  if (!hasTitle && !hasDescription && !hasChildren) return null;

  const iconClassName =
    props.iconClassName &&
    classNames(["text-primary", "text-title-section", props.iconClassName]);

  const className = classNames(
    "page-section",
    "page-section-with-title-and-description",
    props.className
  );

  const titleClassName =
    hasTitle &&
    classNames("with-icon-lg", { "margin-bottom-md": hasDescription || hasChildren });

  const descriptionClassName =
    hasDescription &&
    classNames({
      "margin-top-md": hasTitle,
      "margin-bottom-md": hasChildren
    });

  return (
    <div className={className}>
      <div className="page-section-with-title-and-description-container container box">
        <div className="padding-md">
          {hasTitle && (
            <div className={titleClassName}>
              {iconClassName && <Icon className={iconClassName} />}
              <h2 className="with-icon-text text-title-section">{title}</h2>
            </div>
          )}

          {hasDescription && (
            <ExcerptableContainer
              wrapperClassName={descriptionClassName}
              collapsible={collapsible}
              collapsedHeight={collapsedHeight}
            >
              <RichText content={description} />
            </ExcerptableContainer>
          )}

          {hasChildren && children}
        </div>
      </div>
    </div>
  );
};

export default PageSectionBlockWithTitleAndDescription;
